import type { ReactNode } from 'react'
import { motion } from 'framer-motion'
import { cn, DURATION, EASE_OUT, SHELL, WorkflowMark } from '@workflow/ui'

/**
 * The full-page frame the pre-console screens live in: sign-in, profile
 * setup, and the waiting rooms. It is the app's own ground — the brand
 * band where the sidebar's would be, a narrow measure below — so each gate
 * reads as the same program with its door closed, not a different page that
 * happens to share a colour.
 */
export function GateFrame({ children, width = 'max-w-[24rem]' }: { children: ReactNode; width?: string }) {
  return (
    <div className="min-h-dvh bg-surface">
      <div className="flex select-none items-center gap-2 px-4" style={{ height: SHELL.topStripHeight }}>
        <WorkflowMark size={16} className="text-foreground" />
        <span className="wf-heading text-foreground">Workflow</span>
      </div>

      <div className="flex justify-center px-4 pt-[10vh] pb-16">
        <motion.div
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: DURATION.slow, ease: EASE_OUT }}
          className={cn('w-full', width)}
        >
          {children}
        </motion.div>
      </div>
    </div>
  )
}
